// src/plugins/auth0.ts
import { createAuth0 } from '@auth0/auth0-vue';

const domain =
  import.meta.env.VITE_AUTH0_DOMAIN || (globalThis as any).__AUTH0_DOMAIN__;
const clientId =
  import.meta.env.VITE_AUTH0_CLIENT_ID || (globalThis as any).__AUTH0_CLIENT_ID__;
const audience =
  import.meta.env.VITE_AUTH0_AUDIENCE || (globalThis as any).__AUTH0_AUDIENCE__;
// When AUTH0_REDIRECT_URI is unset at build time, vite.config emits "" — fall
// through to window.location.origin so the app works on any deployed domain.
const redirectUri =
  import.meta.env.VITE_AUTH0_REDIRECT_URI ||
  (globalThis as any).__AUTH0_REDIRECT_URI__ ||
  `${window.location.origin}/auth/callback`;

export const auth0 = createAuth0(
  {
    domain: domain!,
    clientId: clientId!,
    authorizationParams: {
      redirect_uri: redirectUri,
      audience,
      scope: 'openid profile email',
    },
    // Persist tokens (incl. the rotating refresh token) across page loads and
    // app restarts. With 'memory', every cold start fell back to silent auth
    // in a hidden iframe, which needs Auth0's session cookie as a third-party
    // cookie — blocked by Firefox ETP/Safari ITP, so pinned mobile apps forced
    // a fresh login on every launch.
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
    // When the rotating refresh token can't be used (revoked by rotation
    // reuse-detection, past its inactivity/absolute lifetime, or evicted from
    // localStorage), retry silent auth in a hidden iframe against the Auth0
    // SSO cookie before giving up. Where third-party cookies are allowed
    // (Chromium today) this re-mints tokens with no visible redirect; where
    // they're blocked, Auth0 sees no session cookie and the iframe fails fast
    // with login_required, landing in the same interactive-login path as
    // before. Requires frame-src to allow *.auth0.com — see the CSP in
    // flask_backend/create_app.py.
    useRefreshTokensFallback: true,
    // Backstop for the fallback iframe: the default is 60s, which would hang
    // every queued API call for a minute if the iframe can't load at all
    // (offline, CSP misconfiguration) before the login redirect fires.
    authorizeTimeoutInSeconds: 15,
  },
  {
    // Optional Vue plugin options:
    // errorPath: '/auth/callback',
    // skipRedirectCallback: false,
  }
);